const createImage = (filename: string) => {
    const image = new Image();
    image.src = `/wp-content/themes/touchbistro4/assets/svgs/${filename}`;
    return image;
};

export default createImage;
